export const fr: Record<string, string> = {
  'Add': 'Ajouter',
  'Add user to favorites': 'Ajouter l’utilisateur aux favoris',
  'All time': 'Toute la période',
  'Around the point you selected': 'Autour du point sélectionné',
  'Around the visible map area': 'Dans la zone visible de la carte',
  'Back to map': 'Retour à la carte',
  'Back to sign in': 'Retour à la connexion',
  'Cancel manual location placement': 'Annuler le placement manuel',
  'Community map': 'Carte de la communauté',
  'Connecting to your device’s location signal…': 'Connexion à la localisation de votre appareil…',
  'Could not get your current location.': 'Impossible d’obtenir votre position actuelle.',
  'Could not save this location. Please try again.': 'Impossible d’enregistrer cette position. Réessayez.',
  'Create account': 'Créer un compte',
  'Creating account…': 'Création du compte…',
  'Dark Mode': 'Mode sombre',
  'Enable location': 'Activer la localisation',
  'End': 'Fin',
  'Failed to get location': 'Impossible d’obtenir la position',
  'Failed to load application statistics.': 'Impossible de charger les statistiques de l’application.',
  'Failed to load map activity.': 'Impossible de charger l’activité de la carte.',
  'Failed to load statuses': 'Impossible de charger les statuts',
  'Favorite person': 'Personne préférée',
  'Favorite user': 'Utilisateur favori',
  'Find a person in direct messages': 'Rechercher une personne dans les messages privés',
  'Find a person…': 'Rechercher une personne…',
  'Getting location…': 'Localisation en cours…',
  'Hide password': 'Masquer le mot de passe',
  'Hide statuses': 'Masquer les statuts',
  'Home': 'Accueil',
  'Join the map': 'Rejoindre la carte',
  'Last day': 'Dernier jour',
  'Last month': 'Dernier mois',
  'Last week': 'Dernière semaine',
  'Light Mode': 'Mode clair',
  'Like': 'J’aime',
  'Liked': 'Aimé',
  'Live location sharing is active.': 'Le partage de position en direct est actif.',
  'Load older messages': 'Charger les anciens messages',
  'Loading older messages…': 'Chargement des anciens messages…',
  'Manual location is active.': 'La position manuelle est active.',
  'Map friend': 'Ami de la carte',
  'My statuses': 'Mes statuts',
  'Nearby person': 'Personne à proximité',
  'Nearby statuses': 'Statuts à proximité',
  'New people': 'Nouvelles personnes',
  'No nearby stories in this area yet': 'Aucune histoire à proximité dans cette zone',
  'No statuses found': 'Aucun statut trouvé',
  'No stories shared yet': 'Aucune histoire partagée',
  'People and statuses could not be refreshed. Your current map view is still available.': 'Les personnes et les statuts n’ont pas pu être actualisés. La carte actuelle reste disponible.',
  'Place a manual location': 'Placer une position manuelle',
  'Profile': 'Profil',
  'Reconnecting people and nearby stories…': 'Reconnexion aux personnes et histoires à proximité…',
  'Refresh map': 'Actualiser la carte',
  'Remove': 'Supprimer',
  'Remove user from favorites': 'Retirer l’utilisateur des favoris',
  'Reply': 'Répondre',
  'Save': 'Enregistrer',
  'Saved': 'Enregistré',
  'Saving…': 'Enregistrement…',
  'Search all direct messages': 'Rechercher dans tous les messages privés',
  'Search all messages…': 'Rechercher dans tous les messages…',
  'Search failed': 'La recherche a échoué',
  'Searching…': 'Recherche…',
  'Selected avatar': 'Avatar sélectionné',
  'Sending…': 'Envoi…',
  'Set a manual location': 'Définir une position manuelle',
  'Set here': 'Définir ici',
  'Set my location here': 'Définir ma position ici',
  'Set your map location to make this status discoverable nearby.': 'Définissez votre position pour rendre ce statut visible à proximité.',
  'Setting your location…': 'Définition de votre position…',
  'Share Status': 'Partager le statut',
  'Shared from the map': 'Partagé depuis la carte',
  'Sharing…': 'Partage…',
  'Show password': 'Afficher le mot de passe',
  'Show status location on map': 'Afficher la position du statut sur la carte',
  'Signing in…': 'Connexion…',
  'Someone': 'Quelqu’un',
  'Start a conversation': 'Démarrer une conversation',
  'Status details': 'Détails du statut',
  'That status is no longer available.': 'Ce statut n’est plus disponible.',
  'The map is not ready yet.': 'La carte n’est pas encore prête.',
  'The point you selected on the map will be attached to this status.': 'Le point sélectionné sur la carte sera joint à ce statut.',
  "This user hasn't posted any statuses yet": 'Cet utilisateur n’a encore publié aucun statut',
  'Time span': 'Période',
  'Unable to get your location': 'Impossible d’obtenir votre position',
  'Unfavorite user': 'Retirer l’utilisateur des favoris',
  'Unknown User': 'Utilisateur inconnu',
  'Unlike': 'Je n’aime plus',
  'User details': 'Détails de l’utilisateur',
  'User information not available': 'Informations utilisateur indisponibles',
  'View statuses': 'Voir les statuts',
  'Waiting for a precise device location…': 'En attente d’une position précise de l’appareil…',
  'What should nearby people know?': 'Que devraient savoir les personnes à proximité ?',
  'What’s happening around you?': 'Que se passe-t-il autour de vous ?',
  'What’s happening, and when?': 'Que se passe-t-il, et quand ?',
  'What’s the vibe, and where?': 'Quelle est l’ambiance, et où ?',
  'You': 'Vous',
  'Your current map location will be attached so nearby people can discover it.': 'Votre position actuelle sera jointe afin que les personnes à proximité puissent découvrir votre statut.',
  'Your location': 'Votre position',
  'Your map location': 'Votre position sur la carte',
  'Close about mapbl': 'Fermer les informations sur mapbl',
  'Close cluster details': 'Fermer les détails du groupe',
  'Close create status dialog': 'Fermer la création de statut',
  'Close details': 'Fermer les détails',
  'Close direct messages': 'Fermer les messages privés',
  'Close favorites': 'Fermer les favoris',
  'Close map actions': 'Fermer les actions de la carte',
  'Close map details': 'Fermer les détails de la carte',
  'Close menu': 'Fermer le menu',
  'Close notifications': 'Fermer les notifications',
  'Close panel': 'Fermer le panneau',
  'Close search': 'Fermer la recherche',
  'Close statistics': 'Fermer les statistiques',
  'Close status': 'Fermer le statut',
  'Close statuses dialog': 'Fermer la liste des statuts',
  'Close user profile': 'Fermer le profil utilisateur',
  'Close user settings': 'Fermer les paramètres utilisateur',
  'Dismiss about mapbl': 'Masquer les informations sur mapbl',
  'Dismiss create status dialog': 'Masquer la création de statut',
  'Dismiss error': 'Masquer l’erreur',
  'Dismiss map pulse': 'Masquer le pouls de la carte',
  'Dismiss my statuses': 'Masquer mes statuts',
  'Dismiss nearby statuses': 'Masquer les statuts à proximité',
  'Dismiss profile settings': 'Masquer les paramètres du profil',
  'Dismiss status error': 'Masquer l’erreur du statut',
  'Dismiss welcome message': 'Masquer le message de bienvenue',
  'Opening your map…': 'Ouverture de votre carte…',
  'Checking your map identity…': 'Vérification de votre identité sur la carte…',
  'Actions for this map point': 'Actions pour ce point de la carte',
  'Avatar crop zoom': 'Zoom du recadrage de l’avatar',
  'Avatar image URL': 'URL de l’image de l’avatar',
  'Changes to this policy': 'Modifications de cette politique',
  'Effective September 7, 2026': 'En vigueur le 7 septembre 2026',
  'Enter your display name': 'Saisissez votre nom d’affichage',
  'Frame your avatar': 'Cadrez votre avatar',
  'From': 'Du',
  'Here · 50 m': 'Ici · 50 m',
  'How information is used': 'Utilisation des informations',
  'How people will see you': 'Comment les autres vous verront',
  'Information used by the game': 'Informations utilisées par le jeu',
  'JPEG, PNG, or GIF up to 5 MB.': 'JPEG, PNG ou GIF jusqu’à 5 Mo.',
  'Map content is not verified. Treat every status, identity, and location as fictional game content—not fact.': 'Le contenu de la carte n’est pas vérifié. Considérez chaque statut, identité et position comme du contenu fictif, et non comme un fait.',
  'Maps and service providers': 'Cartes et fournisseurs de services',
  'Move the map until the target is over the right place.': 'Déplacez la carte jusqu’à ce que le repère soit au bon endroit.',
  'OpenStreetMap copyright and attribution': 'Droits d’auteur et attribution OpenStreetMap',
  'mapbl is a fantasy experience for fun.': 'mapbl est une expérience imaginaire conçue pour le divertissement.',
  'mapbl version': 'Version de mapbl',
  'mapbl is a playful social map where you can share what is happening, discover nearby statuses, and see the community come alive around you.': 'mapbl est une carte sociale ludique où vous pouvez partager ce qui se passe, découvrir les statuts à proximité et voir la communauté prendre vie autour de vous.',
  'mapbl is a game and creative social experience. Names, profiles, locations, statuses, events, announcements, and other content shown on the map are user-submitted, are not independently verified, and must not be treated as statements of fact. Everything you see should be understood as fictional, role-play, or fantasy content created for entertainment only.': 'mapbl est un jeu et une expérience sociale créative. Les noms, profils, positions, statuts, événements, annonces et autres contenus de la carte sont publiés par les utilisateurs, ne sont pas vérifiés indépendamment et ne doivent pas être considérés comme des faits. Tout ce que vous voyez doit être compris comme du contenu fictif, de jeu de rôle ou imaginaire créé uniquement pour le divertissement.',
  'We process only the information needed to provide the experience: account details you submit, such as your email, display name, bio, avatar, and password in protected hashed form; statuses and reactions you create; a browser-selected or manually selected map location; and sign-in tokens stored on your device. This information is saved only so the game can operate and remember your account and game activity.': 'Nous traitons uniquement les informations nécessaires au service : les données de compte fournies, comme votre adresse e-mail, votre nom d’affichage, votre biographie, votre avatar et votre mot de passe sous forme hachée protégée ; les statuts et réactions créés ; une position sélectionnée par le navigateur ou manuellement ; et les jetons de connexion stockés sur votre appareil. Ces informations sont enregistrées uniquement pour assurer le fonctionnement du jeu et mémoriser votre compte et votre activité.',
  'Submitted information is used only to authenticate you, display and personalize the map, show game content, support nearby discovery, and maintain the service. mapbl does not sell your personal information or use your game activity to make real-world claims about you.': 'Les informations transmises servent uniquement à vous authentifier, afficher et personnaliser la carte, présenter le contenu du jeu, faciliter la découverte à proximité et maintenir le service. mapbl ne vend pas vos informations personnelles et n’utilise pas votre activité pour formuler des affirmations réelles à votre sujet.',
  'The experience is built around a shared map. Your chosen game identity, avatar, bio, approximate or selected location, statuses, and reactions may be visible to other players. Your password and authentication tokens are not displayed to other players. Do not use real-world secrets, sensitive personal details, or a precise real-world location in your public game content.': 'L’expérience repose sur une carte partagée. L’identité de jeu, l’avatar, la biographie, la position approximative ou sélectionnée, les statuts et les réactions peuvent être visibles par les autres joueurs. Votre mot de passe et vos jetons d’authentification ne sont pas affichés. N’utilisez pas de secrets réels, de données personnelles sensibles ni de position réelle précise dans votre contenu public.',
  'The site may rely on hosting, map, and geocoding providers to deliver the service. Those providers may receive ordinary technical requests, such as an IP address and map coordinates, under their own privacy terms. We limit access to stored information to what is necessary to operate and protect the game.': 'Le site peut faire appel à des fournisseurs d’hébergement, de cartes et de géocodage. Ces fournisseurs peuvent recevoir des requêtes techniques habituelles, telles qu’une adresse IP et des coordonnées, selon leurs propres conditions de confidentialité. Nous limitons l’accès aux informations stockées à ce qui est nécessaire pour exploiter et protéger le jeu.',
  'You choose what identity, status, and location to submit. You can update your profile and game content through the available controls, stop sharing a browser location by changing your browser permissions, and sign out to remove sign-in tokens from the device. Please contact the site operator if you need help with your account or stored information.': 'Vous choisissez l’identité, le statut et la position à transmettre. Vous pouvez modifier votre profil et votre contenu avec les commandes disponibles, arrêter le partage de position en modifiant les autorisations du navigateur et vous déconnecter pour supprimer les jetons de l’appareil. Contactez l’exploitant du site si vous avez besoin d’aide concernant votre compte ou vos informations.',
  'We may update this policy as the game changes. The effective date at the top will be revised when that happens. Continued use of mapbl after an update means you accept the revised policy.': 'Nous pouvons mettre à jour cette politique à mesure que le jeu évolue. La date d’entrée en vigueur indiquée en haut sera alors modifiée. Continuer à utiliser mapbl après une mise à jour signifie que vous acceptez la politique révisée.',
  'About': 'À propos',
  'About mapbl': 'À propos de mapbl',
  'About the service': 'À propos du service',
  'Account': 'Compte',
  'All stories': 'Toutes les histoires',
  'Application statistics': 'Statistiques de l’application',
  'Area': 'Zone',
  'Back to conversations': 'Retour aux conversations',
  'Bio': 'Biographie',
  'Cancel': 'Annuler',
  'Choose your map position': 'Choisissez votre position sur la carte',
  'Choose your map vibe': 'Choisissez votre style sur la carte',
  'Clear': 'Effacer',
  'Community first': 'La communauté avant tout',
  'Connection interrupted': 'Connexion interrompue',
  'Could not locate you': 'Impossible de vous localiser',
  'Create Status': 'Créer un statut',
  'Create an account': 'Créer un compte',
  'Create status': 'Créer un statut',
  'Create your identity': 'Créez votre identité',
  'Crop Current Avatar': 'Recadrer l’avatar actuel',
  'Direct Messages': 'Messages privés',
  'Direct messages': 'Messages privés',
  'Display Name': 'Nom d’affichage',
  'Display name': 'Nom d’affichage',
  'Edit': 'Modifier',
  'Edit direct message': 'Modifier le message privé',
  'Edit reply': 'Modifier la réponse',
  'Edited': 'Modifié',
  'Email address': 'Adresse e-mail',
  'Emoji collections': 'Collections d’emojis',
  'Favorite people or statuses to keep them close.': 'Ajoutez des personnes ou statuts aux favoris pour les garder à portée de main.',
  'Favorites': 'Favoris',
  'Filter by status type': 'Filtrer par type de statut',
  'Filter profile statuses': 'Filtrer les statuts du profil',
  'Filter the signal': 'Filtrer le signal',
  'Finding your location': 'Recherche de votre position',
  'Go to my location': 'Aller à ma position',
  'Ignore user': 'Ignorer l’utilisateur',
  'Ignored users': 'Utilisateurs ignorés',
  'Jump to latest messages': 'Aller aux messages récents',
  'Last 24 hours': 'Dernières 24 heures',
  'Last hour': 'Dernière heure',
  'Link (optional)': 'Lien (facultatif)',
  'Live community signal': 'Signal en direct de la communauté',
  'Live map stories': 'Histoires en direct sur la carte',
  'Load more results': 'Charger plus de résultats',
  'Load older': 'Charger les précédents',
  'Load older replies': 'Charger les anciennes réponses',
  'Loading favorites…': 'Chargement des favoris…',
  'Loading ignored users…': 'Chargement des utilisateurs ignorés…',
  'Loading messages…': 'Chargement des messages…',
  'Loading replies…': 'Chargement des réponses…',
  'Loading statuses': 'Chargement des statuts',
  'Loading user data...': 'Chargement des données utilisateur…',
  'Loading…': 'Chargement…',
  'Locating you': 'Localisation en cours',
  'Location needs attention': 'La localisation nécessite votre attention',
  'Make it yours': 'Personnalisez-le',
  'Map': 'Carte',
  'Map avatar preview': 'Aperçu de l’avatar',
  'Map discovery': 'Découverte sur la carte',
  'Map navigation': 'Navigation sur la carte',
  'Map pulse': 'Pouls de la carte',
  'Map refresh paused': 'Actualisation de la carte en pause',
  'Mark all read': 'Tout marquer comme lu',
  'Message': 'Message',
  'Message *': 'Message *',
  'Messages': 'Messages',
  'My Location': 'Ma position',
  'My Statuses': 'Mes statuts',
  'Nearby Statuses': 'Statuts à proximité',
  'Nearby activity': 'Activité à proximité',
  'Nearby radius': 'Rayon de proximité',
  'New status': 'Nouveau statut',
  'No matching messages found.': 'Aucun message correspondant trouvé.',
  'No notifications yet': 'Aucune notification',
  'No people found in your direct messages.': 'Aucune personne trouvée dans vos messages privés.',
  'Nothing shared in this cluster yet': 'Rien n’a encore été partagé dans ce groupe',
  'Notifications': 'Notifications',
  'Notification settings': 'Paramètres des notifications',
  'Number of statuses': 'Nombre de statuts',
  'Observe nearby statuses': 'Observer les statuts à proximité',
  'Open shared link': 'Ouvrir le lien partagé',
  'Password': 'Mot de passe',
  'People': 'Personnes',
  'People and statuses you saved': 'Personnes et statuts enregistrés',
  'People make the map': 'Ce sont les gens qui font la carte',
  'Post a new status or message here': 'Publier un nouveau statut ou message ici',
  'Posted': 'Publié',
  'Privacy & play': 'Confidentialité et jeu',
  'Privacy Policy': 'Politique de confidentialité',
  'Private conversation': 'Conversation privée',
  'Private conversations': 'Conversations privées',
  'Profile settings': 'Paramètres du profil',
  'Reading the map pulse…': 'Lecture du pouls de la carte…',
  'Ready to upload': 'Prêt à envoyer',
  'Recent': 'Récent',
  'Recent searches': 'Recherches récentes',
  'Refresh': 'Actualiser',
  'Refresh statuses': 'Actualiser les statuts',
  'Refreshing the map': 'Actualisation de la carte',
  'Reload mapbl': 'Recharger mapbl',
  'Replies and direct messages': 'Réponses et messages privés',
  'Reply to status': 'Répondre au statut',
  'Say hello to start the conversation.': 'Dites bonjour pour démarrer la conversation.',
  'Search a wider area': 'Rechercher dans une zone plus large',
  'Search every message in your direct conversations.': 'Recherchez dans tous les messages de vos conversations privées.',
  'Select a conversation to read your messages.': 'Sélectionnez une conversation pour lire vos messages.',
  'Selected map point': 'Point sélectionné sur la carte',
  'Selected period': 'Période sélectionnée',
  'Send direct message': 'Envoyer un message privé',
  'Settings': 'Paramètres',
  'Share nearby': 'Partager à proximité',
  'Short bio': 'Courte biographie',
  'Show': 'Afficher',
  'Sign in': 'Se connecter',
  'Sign in to mapbl': 'Se connecter à mapbl',
  'Start must be before end.': 'Le début doit précéder la fin.',
  'Status reply': 'Réponse au statut',
  'Statuses': 'Statuts',
  'Stop ignoring': 'Ne plus ignorer',
  'Surprise me': 'Surprenez-moi',
  'Surprise me with an emoji': 'Surprenez-moi avec un emoji',
  'The map hit a rough patch': 'La carte a rencontré un problème',
  'Time': 'Temps',
  'Time filter': 'Filtre temporel',
  'Time span end': 'Fin de la période',
  'Time span start': 'Début de la période',
  'To': 'Au',
  'Toggle menu': 'Ouvrir ou fermer le menu',
  'Try again': 'Réessayer',
  'Unread': 'Non lu',
  'Updated': 'Mis à jour',
  'Use a photo': 'Utiliser une photo',
  'Use an image URL instead': 'Utiliser plutôt une URL d’image',
  'Use emoji': 'Utiliser un emoji',
  'Use this crop': 'Utiliser ce recadrage',
  'What are you sharing?': 'Que partagez-vous ?',
  'Width': 'Largeur',
  'Write a direct message': 'Écrire un message privé',
  'Write a message…': 'Écrivez un message…',
  'Write a reply…': 'Écrivez une réponse…',
  'You are not ignoring anyone.': 'Vous n’ignorez personne.',
  'Your map identity': 'Votre identité sur la carte',
  'Your password': 'Votre mot de passe',
  'Your recent posts and moments': 'Vos publications et moments récents',
  'You’re on the map': 'Vous êtes sur la carte',
  'Zoom': 'Zoom',
  'edited': 'modifié',
  'latest': 'plus récents',
  'optional': 'facultatif',
  'or set it manually on the map': 'ou définissez-la manuellement sur la carte',
  'statuses': 'statuts',
  'sent you a message': 'vous a envoyé un message',
  'replied to your status': 'a répondu à votre statut',
  'Just now': 'À l’instant',
  'Statuses (': 'Statuts (',
  'Users (': 'Utilisateurs (',
  'people ·': 'personnes ·',
  'Failed to update profile': 'Impossible de mettre à jour le profil',
  'Failed to upload avatar': 'Impossible d’envoyer l’avatar',
  'Failed to log out': 'Impossible de se déconnecter',
  'Please select a valid image file (JPEG, PNG, GIF)': 'Sélectionnez une image valide (JPEG, PNG ou GIF)',
  'File size must be less than 5MB': 'Le fichier doit faire moins de 5 Mo',
  'Failed to load current avatar image for cropping': 'Impossible de charger l’avatar actuel pour le recadrer',
  'Geolocation is not supported by this browser': 'Ce navigateur ne prend pas en charge la géolocalisation',
  'Geolocation is not supported by this browser.': 'Ce navigateur ne prend pas en charge la géolocalisation.',
  'Location permission denied': 'Autorisation de localisation refusée',
  'Location permission denied. Please enable location access in your browser settings.': 'Autorisation de localisation refusée. Activez-la dans les paramètres du navigateur.',
  'Location request timed out. Please try again.': 'La demande de localisation a expiré. Réessayez.',
  'Location tracking failed': 'Le suivi de position a échoué',
  'Location tracking timed out': 'Le suivi de position a expiré',
  'Location unavailable': 'Position indisponible',
  'Location unavailable. Please check your GPS or network connection.': 'Position indisponible. Vérifiez votre GPS ou votre connexion réseau.',
  'A fantasy map made for fun': 'Une carte imaginaire conçue pour s’amuser',
  'A little about you': 'Quelques mots sur vous',
  'A quick look at how the community is moving.': 'Un aperçu rapide de l’activité de la communauté.',
  'Bright, friendly, and a little futuristic.': 'Lumineux, convivial et un peu futuriste.',
  'Choose a photo or an upbeat emoji. This is how people recognize you on the map.': 'Choisissez une photo ou un emoji joyeux. C’est ainsi que les autres vous reconnaîtront sur la carte.',
  'Choose how long new live locations and statuses animate on the map.': 'Choisissez combien de temps les nouvelles positions et les nouveaux statuts en direct s’animent sur la carte.',
  'Choose someone on the map to start a conversation.': 'Choisissez quelqu’un sur la carte pour démarrer une conversation.',
  'Drag to position, then fine-tune the zoom.': 'Faites glisser pour positionner, puis ajustez le zoom.',
  'Find the bright moments happening around you.': 'Découvrez les beaux moments autour de vous.',
  'Share a location, leave a status, and discover the people and energy nearby.': 'Partagez une position, publiez un statut et découvrez les personnes et l’activité à proximité.',
  'Sign out of mapbl on this device.': 'Se déconnecter de mapbl sur cet appareil.',
  'Tell us about yourself': 'Parlez-nous de vous',
  'Their locations, statuses, and direct messages are hidden both ways.': 'Leurs positions, statuts et messages privés sont masqués dans les deux sens.',
  'What other players can see': 'Ce que les autres joueurs peuvent voir',
  'Your choices': 'Vos choix',
  '5 seconds': '5 secondes',
  '10 seconds': '10 secondes',
  'A quick heads-up': 'Une brève notification',
  'Recommended': 'Recommandé',
  'Never': 'Jamais',
  'Keep markers still': 'Garder les marqueurs immobiles',
  'Until I open it': 'Jusqu’à ce que je l’ouvre',
  'Animate until selected': 'Animer jusqu’à la sélection',
  'Uploading…': 'Envoi…',
  'Upload avatar': 'Envoyer l’avatar',
  'Logging out…': 'Déconnexion…',
  'Logout': 'Se déconnecter',
  'Updating…': 'Mise à jour…',
  'Update Profile': 'Mettre à jour le profil',
  'Language': 'Langue',
  'Interface language': 'Langue de l’interface',
  'English': 'Anglais',
  'Ukrainian': 'Ukrainien',
  'Spanish': 'Espagnol',
  'French': 'Français',
  'Norwegian': 'Norvégien',
  'Dutch': 'Néerlandais',
  'Romanian': 'Roumain',
  'Profile updated successfully!': 'Profil mis à jour !',
  'Avatar uploaded successfully!': 'Avatar envoyé !',
  'Welcome back': 'Bon retour',
  'Your map, people, and nearby moments are waiting.': 'Votre carte, les personnes et les moments à proximité vous attendent.',
  'New to mapbl?': 'Nouveau sur mapbl ?',
  'Already on mapbl?': 'Déjà sur mapbl ?',
  'Password is required': 'Le mot de passe est requis',
  'Email is required': 'L’adresse e-mail est requise',
  'Enter a valid email address': 'Saisissez une adresse e-mail valide',
  'At least 6 characters': 'Au moins 6 caractères',
  'Your account and map data are safe. Reload mapbl to reconnect and pick up where you left off.': 'Votre compte et les données de la carte sont en sécurité. Rechargez mapbl pour vous reconnecter et reprendre où vous en étiez.',
};
